<template>
<div>
    <v-container>
        <v-row>
            <v-col>
                <StockCodeAutocomplete
                    v-model="select"
                    @updateStockName="updateStockName"/>
            </v-col>
            <v-col>
                <v-btn @click="viewGraph">View</v-btn>
            </v-col>
        </v-row>
    

        <h2>カブコム一般信用</h2>
        <div id="main" style="width: 100%;height:600px;"></div>
        <v-data-table
            :headers="Headers"
            :items="KabucomCrosses"
            :sort-by="['date']"
            :sort-desc="[true]"
        ></v-data-table>
        <h2>SMBC一般信用</h2>
        <div id="main2" style="width: 100%;height:600px;"></div>
        <v-data-table
            :headers="Headers"
            :items="SmbcCrosses"
            :sort-by="['date']"
            :sort-desc="[true]"
        ></v-data-table>

    </v-container>

    <v-overlay :value="loading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

</div>
</template>

<script>
import axios from 'axios';
import StockCodeAutocomplete from "../components/StockCodeAutocomplete";

export default {
    data () {
        return {
            select: null,
            loading: false,
            kabucomLoading: false,
            smbcLoading:false,
            KabucomCrosses: [],
            SmbcCrosses: [],
            Headers: [
                {
                    text: "日時",
                    align: 'start',
                    value: "date",
                },
                { text: "残株数", value: 'remain' },
                { text: "倍率", value: 'chance' },
            ],
            pagenation: {
                sortBy: 'date',
                descending: true,
            },
        }
    },
    mounted () {
        this.drawGraphArea(this.$route.params.code);
    },
    components: {
        StockCodeAutocomplete,
    },
    methods: {
      updateStockName(value) {
          this.select=value;
      },
      viewGraph() {
        this.drawGraphArea(this.select.slice(0,4));
        console.log(this.select.slice(0,4));
      },
      drawGraphArea(code) {
        this.loading = true;
        this.kabucomLoading = true;
        this.smbcLoading = true;
        axios
            .get('/api/v1/crosses/kabucom/'+code)
            .then(response => {
                this.KabucomCrosses=response.data;
                drawGraph(this.KabucomCrosses,'main');
                this.kabucomLoading = false;
                if (this.smbcLoading == false) {
                    this.loading = false;
                }
            })
        axios
            .get('/api/v1/crosses/smbc/'+code)
            .then(response => {
                this.SmbcCrosses=response.data;
                drawGraph(this.SmbcCrosses,'main2')
                this.smbcLoading = false;
                if (this.kabucomLoading == false) {
                    this.loading = false;
                }
            })
        
      },
    },
}

function drawGraph(response,drawid) {
    // based on prepared DOM, initialize echarts instance
    var myChart = echarts.init(document.getElementById(drawid));
    
    var upColor = '#8A0000';
    var downColor = '#6B9994'
    var upBorderColor = '#8A0000';

    var dataCount = 2e5;
    var data = response;

    var option = {
        dataset: {
            source: data
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'line'
            }
        },
        toolbox: {
            feature: {
                dataZoom: {
                    yAxisIndex: false
                },
            }
        },
        xAxis: [
            {
                type: 'category',
                scale: true,
                boundaryGap : false,
                // inverse: true,
                axisLine: {onZero: false},
                splitLine: {show: false},
                splitNumber: 10,
                min: 'dataMin',
                max: 'dataMax'
            }
        ],
        yAxis: [
            {
                scale: true,
                name: '残数量',
                splitArea: {
                    show: true
                }
            },
            {
                scale: true,
                splitLine: {show: false},
                name: '倍率'
            }
        ],
        series: [
            {
                type: 'bar',
                itemStyle: {
                    color: upColor,
                    borderColor: upBorderColor
                },
                encode: {
                    x: 0,
                    y: 1
                }
            },
            {
                type: 'line',
                yAxisIndex: 1,
                itemStyle: {
                    color: downColor
                },
                encode: {
                    x: 0,
                    y: 2
                }
            }

        ]
    };
        // use configuration item and data specified to show chart
        myChart.setOption(option);
};

</script>